/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-answer.reducer';

export const SurveyAnswerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyAnswerEntity = useAppSelector(state => state.surveyAnswer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyAnswerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyAnswer.detail.title">SurveyAnswer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.id}</dd>
          <dt>
            <span id="answerNumeric">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.answerNumeric">Answer Numeric</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.answerNumeric}</dd>
          <dt>
            <span id="answerText">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.answerText">Answer Text</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.answerText}</dd>
          <dt>
            <span id="answer">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.answer">Answer</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.answer ? 'true' : 'false'}</dd>
          <dt>
            <span id="comment">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.comment">Comment</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.comment}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyAnswer.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyAnswerEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyAnswer.unitOfMeasure">Unit Of Measure</Translate>
          </dt>
          <dd>{surveyAnswerEntity.unitOfMeasure ? surveyAnswerEntity.unitOfMeasure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyAnswer.questionOption">Question Option</Translate>
          </dt>
          <dd>{surveyAnswerEntity.questionOption ? surveyAnswerEntity.questionOption.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/survey-answer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-answer/${surveyAnswerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyAnswerDetail;
